function findProjectViewFilter({topProjectId, viewId}){
    return {topProjectId, viewId}
}

export {findProjectViewFilter}